<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'MaDianjianDialog',
})
</script>
<template>
	<ma-data-table
		:key="visible + ''"
		v-model:visible="visible"
		:title="t('maDianjian.title')"
		row-key="id"
		url="/maku/biz_device_check_project_item/page"
		method="post"
		:multiple="true"
		:columns="[
			{ field: 'id', label: t('maDianjian.projectId') },
			{ field: 'projectName', label: t('maDianjian.projectName') },
			{ field: 'method', label: t('maDianjian.method') }
		]"
		:query-params="[{ field: 'projectName', label: t('maDianjian.projectName'), type: 'input' }]"
		@select="onSelect"
	></ma-data-table>
</template>

<script setup lang="ts" name="MaDianjianDialog">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
defineProps({
	multiple: {
		type: Boolean,
		required: false,
		default: false
	}
})

const visible = defineModel<boolean>()

const emit = defineEmits(['select'])
const onSelect = (rows: any[]) => {
	emit('select', rows)
}
</script>
